import React, { FunctionComponent, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import { Box, Typography, SvgIcon } from "@mui/material";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import TableSearch from "../../Components/Table/components/TableSearch";
import IconButtonField from "../../Components/Button/IconButtonField";
import { Columns } from "../../Components/Table/ITable";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { getRoleMapping } from "../../Redux/Slices/RoleMapping/RoleMappingList";
import RoleScreenMappingModal from "./RoleScreenMappingModal";
import { IRoleMapping } from "./IRoleMappingMaster";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import LaunchIcon from '@mui/icons-material/Launch';
import { ISideMenu } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";

const RoleMappingMaster: FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState<number | undefined>(undefined);
    const location = useLocation();
    const screen_search_query = location.state?.screen_search_query;

    const { data: roleMappingData, isLoading } = useAppSelector(
        (state) => state.RoleMappingScreens
    );

    // user permission logic (pattern from Role.tsx)
    const userPermissionlist = useAppSelector(
        (state) => (state.SideMenuPermission as ISideMenu).data
    );

    const navigate = useNavigate();

    const to = "settings";
    const filteredList = userPermissionlist?.Dashboard?.filter(
        (item: any) => item.to === to
    ) || [];
    const fliterdata: any = filteredList[0]?.items || [];
    const finaldata = fliterdata.find((item: any) => item.to === "role-mapping-master") || fliterdata[0];

    const handleEdit = (roleId: number) => {
        setSelectedRoleId(roleId);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedRoleId(undefined);
        // Refresh the role mapping data after closing modal
        dispatch(getRoleMapping());
    };

    const columns: Columns = [
        {
            field: "index",
            renderHeader: () => <b>S.No</b>,
            width: 90,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "role_name",
            renderHeader: () => <b>Role</b>,
            flex: 1,
            type: "string",
            headerAlign: "left",
        },
        {
            field: "screen_count",
            renderHeader: () => <b>Total Screens</b>,
            flex: 1,
            // width: 110,
            type: "number",
            headerAlign: "center",
            align: "center",
        },
        {
            field: "action",
            renderHeader: () => <b>Action</b>,
            flex: 1,
            type: "actions",
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <>
                    <IconButtonField
                        disabled={finaldata?.permissions?.edit === false}
                        onClick={() => handleEdit(params.row.role_id)}
                    >
                        <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
                    </IconButtonField>
                    <IconButtonField
                        disabled={params?.row?.role_name == "ADMIN" || params?.row?.screen_count == 0}
                        onClick={() => {
                            navigate("/settings/role_permission", {
                                state: {
                                    role_id: params.row.role_id,
                                    role_name: params.row.role_name
                                }
                            })
                        }}
                    >
                        <LaunchIcon />
                    </IconButtonField>
                </>
            ),
        },
    ];

    const roles = Array.isArray(roleMappingData?.data)
        ? (roleMappingData?.data || []).map((role: IRoleMapping, index: number) => ({
            ...role,
            index: index + 1,
        }))
        : [];

    useEffect(() => {
        dispatch(getRoleMapping());
    }, [dispatch]);

    return (
        <>
            <Table
                rows={roles}
                columns={columns}
                loading={isLoading}
                getRowId={(row) => row.role_id}
                initialSearchValue={screen_search_query}
                sx={{
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: 2,
                }}
            >
                <CustomToolbar>
                    <Typography variant="h6" component="h6"></Typography>
                    <TableSearch />
                </CustomToolbar>
            </Table>

            <RoleScreenMappingModal
                open={modalOpen}
                onClose={handleCloseModal}
                roles={roles}
                selectedRoleId={selectedRoleId}
            />
        </>
    );
};

export default RoleMappingMaster;
